export default __webpack_public_path__ + "static/pembayaranBank-7ef41046ee1946023e80740ffd354677.png";